const css = `body,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: none;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a[href],
button,
[role=button] {
  cursor: pointer;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

input {
  margin: 0;
  padding: 0;
}

input:disabled {
  opacity: 1; /* required on iOS */
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  margin: 0;
}

fieldset {
  min-inline-size: auto;
}

.vuiAccordionHeader {
  font-size: 14px;
  border-bottom: 1px solid #cbcdde;
  width: 100%;
  padding: 8px 0;
}
.vuiAccordionHeader:hover {
  text-decoration: underline;
  background-color: #f3f7fb;
}

.vuiAccordionHeader__title {
  text-align: left;
}

.vuiAppContent {
  width: 100%;
  max-width: 1200px;
}

.vuiAppContent--fullWidth {
  max-width: 100%;
}

.vuiAppContent--paddingNone {
  padding: 0;
}

.vuiAppContent--paddingXs {
  padding: 8px 10px;
}

.vuiAppContent--paddingS {
  padding: 12px 15px;
}

.vuiAppContent--paddingM {
  padding: 16px 20px;
}

.vuiAppContent--paddingL {
  padding: 24px 30px;
}

.vuiAppContent--paddingXl {
  padding: 32px 40px;
}

.vuiAppHeader {
  position: fixed;
  display: flex;
  align-items: center;
  width: 100vw;
  height: 46px;
  background-color: #f3f7fb;
  padding: 8px 16px;
  z-index: 8;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.vuiAppHeader__inner {
  flex-grow: 1;
}

.vuiAppLayout {
  display: flex;
  flex-direction: row;
  padding-top: 46px;
  height: 100vh;
}

.vuiAppLayout--full {
  padding-top: 0;
}

.vuiAppLayout__sideNav {
  border-right: 1px solid #cbcdde;
  flex-shrink: 0;
  overflow-y: auto;
}

.vuiAppLayout__content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.vuiAppSideNav {
  width: 240px;
  overflow-x: hidden;
  transition: all 0.2s;
  line-height: 1;
}

.vuiAppSideNav__inner {
  width: 240px;
  padding: 28px 32px 32px 33px;
  margin-bottom: 160px;
  transition: all 0.2s;
}

.vuiAppSideNavContent {
  opacity: 1;
  transition: all 0.2s;
}

.vuiAppSideNavContent-isHidden {
  pointer-events: none;
  opacity: 0;
}

.vuiAppSideNav-isCollapsed {
  width: 60px;
  height: 100%;
  overflow-y: hidden;
}
.vuiAppSideNav-isCollapsed .vuiAppSideNav__inner {
  padding-left: 16px;
}

.vuiAppSideNavCollapseButton {
  display: block;
  color: #69707d;
  font-size: 14px;
  text-decoration: none;
  padding: 0 16px;
  margin-left: -40px;
  margin-bottom: 16px;
}
.vuiAppSideNavCollapseButton:hover {
  color: rgb(38, 76, 214);
  text-decoration: underline;
}

.vuiAppSideNavExpandButton {
  margin-top: -4px;
  margin-bottom: 6px;
}

.vuiAppSideNavLink {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  color: #2c313a;
  font-size: 14px;
  padding: 0 16px;
  margin-left: -16px;
  padding-top: 6px;
  padding-bottom: 6px;
  text-decoration: none;
}
.vuiAppSideNavLink * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiAppSideNavLink:hover {
  color: rgb(38, 76, 214);
  text-decoration: underline;
}

.vuiAppSideNavLink--active {
  background-color: rgb(217, 226, 255);
  border-radius: 16px;
}

.vuiAppSideNavSections {
  margin-top: 24px;
}

.vuiAppSideNavContent-isHidden .vuiAppSideNavSections {
  margin-top: 8px;
}

.vuiAppSideNavSection + .vuiAppSideNavSection {
  margin-top: 24px;
}

.vuiAppSideNavSection__title {
  color: #2c313a;
  font-weight: 600;
  font-size: 14px;
}

.vuiAppSideNavSection__items {
  margin-top: 12px;
}
.vuiAppSideNavSection__items > .vuiAppSideNavLink:first-child {
  margin-top: -6px;
}
.vuiAppSideNavSection__items > .vuiAppSideNavLink:last-child {
  margin-bottom: -6px;
}

.vuiAppSideNavTree {
  margin-top: -4px;
}

.vuiAppSideNavTreeSection {
  position: relative;
}

.vuiAppSideNavTreeToggleButton {
  position: absolute;
  top: 0;
  right: -30px;
}

.vuiAppSideNavTreeChildren {
  margin-left: 20px;
}

.vuiAppSideNavTreeSection__subTitle {
  display: block;
  color: #2c313a;
  font-size: 14px;
  padding: 0 16px;
  margin-left: -16px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #69707d;
}

.vuiAccountMenu {
  min-width: 260px;
}

.vuiAccounrMenuHeader {
  padding: 12px;
  border-bottom: 1px solid #e3e4f3;
  background-color: #f3f7fb;
}

.vuiAccountMenuHeaderItem__title {
  font-size: 12px;
  font-weight: 600;
  color: #2c313a;
}

.vuiAccountMenuHeaderItem__value {
  font-size: 14px;
  color: #2c313a;
  margin-top: 4px;
}

.vuiBadge {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 12px;
  font-family: inherit;
  white-space: nowrap;
  text-decoration: none;
}

.vuiBadge--clickable {
  cursor: pointer;
}

.vuiBadge--accent {
  color: #551edf !important;
  background-color: rgba(85, 30, 223, 0.1);
  border: 1px solid rgba(85, 30, 223, 0.1);
  transition: all 0.2s;
}
.vuiBadge--accent.vuiBadge--clickable:hover {
  border-color: #551edf;
  text-decoration: none;
}

.vuiBadge--primary {
  color: rgb(38, 76, 214) !important;
  background-color: rgba(38, 76, 214, 0.1);
  border: 1px solid rgba(38, 76, 214, 0.1);
  transition: all 0.2s;
}
.vuiBadge--primary.vuiBadge--clickable:hover {
  border-color: rgb(38, 76, 214);
  text-decoration: none;
}

.vuiBadge--success {
  color: #04821f !important;
  background-color: rgba(4, 130, 31, 0.1);
  border: 1px solid rgba(4, 130, 31, 0.1);
  transition: all 0.2s;
}
.vuiBadge--success.vuiBadge--clickable:hover {
  border-color: #04821f;
  text-decoration: none;
}

.vuiBadge--warning {
  color: #965a15 !important;
  background-color: rgba(150, 90, 21, 0.1);
  border: 1px solid rgba(150, 90, 21, 0.1);
  transition: all 0.2s;
}
.vuiBadge--warning.vuiBadge--clickable:hover {
  border-color: #965a15;
  text-decoration: none;
}

.vuiBadge--danger {
  color: #c41535 !important;
  background-color: rgba(196, 21, 53, 0.1);
  border: 1px solid rgba(196, 21, 53, 0.1);
  transition: all 0.2s;
}
.vuiBadge--danger.vuiBadge--clickable:hover {
  border-color: #c41535;
  text-decoration: none;
}

.vuiBadge--neutral {
  color: #2c313a !important;
  background-color: #f3f7fb;
  border: 1px solid rgba(44, 49, 58, 0.1);
  transition: all 0.2s;
}
.vuiBadge--neutral.vuiBadge--clickable:hover {
  border-color: #2c313a;
  text-decoration: none;
}

.vuiBaseButtonIconContainer {
  line-height: 0;
}

.vuiBaseButtonLinkWrapper {
  text-decoration: none;
}
.vuiBaseButtonLinkWrapper:hover {
  text-decoration: none;
}

.vuiBaseButtonLinkWrapper--fullWidth {
  width: 100%;
}

.vuiBaseButton {
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  line-height: 1;
  cursor: pointer;
}

.vuiBaseButton--alignLeft {
  justify-content: flex-start;
}

.vuiBaseButton--alignCenter {
  justify-content: center;
}

.vuiBaseButton--alignRight {
  justify-content: flex-end;
}

.vuiBaseButton-isInert,
.vuiBaseButton-isDisabled {
  cursor: default;
  pointer-events: none;
}

.vuiBaseButton-isDisabled {
  opacity: 0.5;
}

.vuiBaseButton--left .vuiBaseButtonIconContainer {
  margin-right: 8px;
}

.vuiBaseButton--right {
  flex-direction: row-reverse;
}
.vuiBaseButton--right .vuiBaseButtonIconContainer {
  margin-left: 8px;
  margin-right: 0;
}

.vuiBaseButton--fullWidth {
  width: 100%;
}

.vuiBaseButton--xs {
  font-size: 14px;
  padding: 4px 8px;
  height: 24px;
}

.vuiBaseButton--s {
  font-size: 14px;
  padding: 6px 8px;
  height: 28px;
}

.vuiBaseButton--m {
  font-size: 16px;
  padding: 8px 16px;
  height: 34px;
}

.vuiBaseButton--l {
  font-size: 16px;
  padding: 12px 24px;
  height: 47px;
}

.vuiButtonPrimary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonPrimary--accent {
  color: #ffffff;
  background-color: #551edf;
  border: 1px solid #551edf;
}
.vuiButtonPrimary--accent.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--primary {
  color: #ffffff;
  background-color: rgb(38, 76, 214);
  border: 1px solid rgb(38, 76, 214);
}
.vuiButtonPrimary--primary.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--success {
  color: #ffffff;
  background-color: #04821f;
  border: 1px solid #04821f;
}
.vuiButtonPrimary--success.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--danger {
  color: #ffffff;
  background-color: #c41535;
  border: 1px solid #c41535;
}
.vuiButtonPrimary--danger.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--warning {
  color: #ffffff;
  background-color: #965a15;
  border: 1px solid #965a15;
}
.vuiButtonPrimary--warning.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--neutral {
  color: #2c313a;
  background-color: rgba(44, 49, 58, 0.1);
  border: 1px solid rgba(44, 49, 58, 0.1);
}
.vuiButtonPrimary--neutral.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--subdued {
  color: #69707d;
  background-color: rgba(105, 112, 125, 0.1);
  border: 1px solid rgba(105, 112, 125, 0.1);
}
.vuiButtonPrimary--subdued.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonSecondary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonSecondary--solid {
  background-color: #ffffff;
}

.vuiButtonSecondary--accent {
  border: 1px solid rgba(85, 30, 223, 0.5);
  color: #551edf;
}
.vuiButtonSecondary--accent.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--primary {
  border: 1px solid rgba(38, 76, 214, 0.5);
  color: rgb(38, 76, 214);
}
.vuiButtonSecondary--primary.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--success {
  border: 1px solid rgba(4, 130, 31, 0.5);
  color: #04821f;
}
.vuiButtonSecondary--success.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--danger {
  border: 1px solid rgba(196, 21, 53, 0.5);
  color: #c41535;
}
.vuiButtonSecondary--danger.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--warning {
  border: 1px solid rgba(150, 90, 21, 0.5);
  color: #965a15;
}
.vuiButtonSecondary--warning.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--neutral {
  border: 1px solid #cbcdde;
  color: #2c313a;
}
.vuiButtonSecondary--neutral.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--subdued {
  border: 1px solid #e3e4f3;
  color: #69707d;
}
.vuiButtonSecondary--subdued.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonTertiary {
  padding-left: 8px;
  padding-right: 8px;
}
.vuiButtonTertiary:hover {
  text-decoration: underline;
}

.vuiButtonTertiary-noPadding {
  padding: 0;
}

.vuiButtonTertiary--accent {
  color: #551edf;
}
.vuiButtonTertiary--accent.vuiButtonTertiary-isSelected {
  background-color: rgba(85, 30, 223, 0.1);
}

.vuiButtonTertiary--primary {
  color: rgb(38, 76, 214);
}
.vuiButtonTertiary--primary.vuiButtonTertiary-isSelected {
  background-color: rgba(38, 76, 214, 0.1);
}

.vuiButtonTertiary--success {
  color: #04821f;
}
.vuiButtonTertiary--success.vuiButtonTertiary-isSelected {
  background-color: rgba(4, 130, 31, 0.1);
}

.vuiButtonTertiary--danger {
  color: #c41535;
}
.vuiButtonTertiary--danger.vuiButtonTertiary-isSelected {
  background-color: rgba(196, 21, 53, 0.1);
}

.vuiButtonTertiary--warning {
  color: #965a15;
}
.vuiButtonTertiary--warning.vuiButtonTertiary-isSelected {
  background-color: rgba(150, 90, 21, 0.1);
}

.vuiButtonTertiary--neutral {
  color: #2c313a;
}
.vuiButtonTertiary--neutral.vuiButtonTertiary-isSelected {
  background-color: rgba(44, 49, 58, 0.1);
}

.vuiButtonTertiary--subdued {
  color: #69707d;
}
.vuiButtonTertiary--subdued.vuiButtonTertiary-isSelected {
  background-color: rgba(105, 112, 125, 0.1);
}

.vuiIconButton {
  display: inline-block;
  border-radius: 4px;
  padding: 4px;
  line-height: 1;
}

.vuiIconButton--accent {
  color: #551edf;
  background-color: rgba(85, 30, 223, 0);
  transition: all 0.2s;
}
.vuiIconButton--accent:hover {
  background-color: rgba(85, 30, 223, 0.1);
}

.vuiIconButton--primary {
  color: rgb(38, 76, 214);
  background-color: rgba(38, 76, 214, 0);
  transition: all 0.2s;
}
.vuiIconButton--primary:hover {
  background-color: rgba(38, 76, 214, 0.1);
}

.vuiIconButton--success {
  color: #04821f;
  background-color: rgba(4, 130, 31, 0);
  transition: all 0.2s;
}
.vuiIconButton--success:hover {
  background-color: rgba(4, 130, 31, 0.1);
}

.vuiIconButton--warning {
  color: #965a15;
  background-color: rgba(150, 90, 21, 0);
  transition: all 0.2s;
}
.vuiIconButton--warning:hover {
  background-color: rgba(150, 90, 21, 0.1);
}

.vuiIconButton--danger {
  color: #c41535;
  background-color: rgba(196, 21, 53, 0);
  transition: all 0.2s;
}
.vuiIconButton--danger:hover {
  background-color: rgba(196, 21, 53, 0.1);
}

.vuiIconButton--neutral {
  color: #2c313a;
  background-color: rgba(44, 49, 58, 0);
  transition: all 0.2s;
}
.vuiIconButton--neutral:hover {
  background-color: rgba(44, 49, 58, 0.1);
}

.vuiIconButton--subdued {
  color: #69707d;
  background-color: rgba(105, 112, 125, 0);
  transition: all 0.2s;
}
.vuiIconButton--subdued:hover {
  background-color: rgba(105, 112, 125, 0.1);
}

.vuiIconButton--xs {
  padding: 4px;
  height: 24px;
}

.vuiIconButton--s {
  padding: 6px;
  height: 28px;
}

.vuiIconButton--m {
  padding: 8px;
  height: 34px;
}

.vuiCallout {
  width: 100%;
}

.vuiCallout--m {
  padding: 16px;
}
.vuiCallout--m .vuiCallout__closeButton {
  margin: -8px;
}

.vuiCallout--s {
  padding: 12px;
}
.vuiCallout--s .vuiCallout__closeButton {
  margin: -6px;
}

.vuiCallout--accent {
  background-color: rgba(85, 30, 223, 0.1);
}

.vuiCallout--primary {
  background-color: rgb(217, 226, 255);
}

.vuiCallout--success {
  background-color: rgba(4, 130, 31, 0.1);
}

.vuiCallout--warning {
  background-color: rgba(150, 90, 21, 0.1);
}

.vuiCallout--danger {
  background-color: #fae9eb;
}

.vuiCallout--neutral {
  background-color: #f3f7fb;
}

.vuiCard {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  width: 100%;
  height: 100%;
  transition: box-shadow 0.2s;
  overflow: hidden;
}

.vuiCard--interactive:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  z-index: 1;
}

.vuiCard--ungrouped {
  height: auto;
}

.vuiCard--center {
  align-items: center;
  text-align: center;
}
.vuiCard--center .vuiCard__header,
.vuiCard--center .vuiCard__body,
.vuiCard--center .vuiCard__footer {
  align-items: center;
  text-align: center;
}

.vuiCard--left {
  align-items: flex-start;
  text-align: left;
}
.vuiCard--left .vuiCard__header,
.vuiCard--left .vuiCard__body,
.vuiCard--left .vuiCard__footer {
  align-items: flex-start;
  text-align: left;
}

.vuiCard__header {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 24px;
}

.vuiCard__body {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid #e3e4f3;
  padding: 16px 24px;
  flex-grow: 1;
}

.vuiCard__footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 16px;
}

.vuiCard--s .vuiCard__header,
.vuiCard--s .vuiCard__body {
  padding: 16px 24px;
}
.vuiCard--s .vuiCard__footer {
  padding: 0 24px 16px;
}

.vuiCard--m .vuiCard__header,
.vuiCard--m .vuiCard__body {
  padding: 24px 32px;
}
.vuiCard--m .vuiCard__footer {
  padding: 0 32px 24px;
}

.vuiCard--l .vuiCard__header,
.vuiCard--l .vuiCard__body {
  padding: 32px 40px;
}
.vuiCard--l .vuiCard__footer {
  padding: 0 40px 32px;
}

.vuiCard--highlight {
  border: 2px solid #551edf;
}
.vuiCard--highlight .vuiCard__header {
  background-color: #eadfff;
}
.vuiCard--highlight .vuiCard__body {
  border-top: #eadfff;
}

.vuiChatTurn {
  position: relative;
  left: 0;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: #ffffff;
  padding: 24px 12px 24px 24px;
  margin-right: 4px;
  transition: all 0.2s;
}
.vuiChatTurn:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  z-index: 1;
  left: 4px;
}

.vuiChatTurn + .vuiChatTurn {
  margin-top: 1px;
}

.vuiChatQuestion {
  color: #551edf;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
}

.vuiChatQuestion--error {
  color: #c41535;
}

.vuiChat__inspectButton {
  margin-top: -4px;
}

.vuiChatAnswer {
  color: #000;
}

.vuiChatButton,
.vuiChat {
  position: fixed;
  right: 4px;
  bottom: 4px;
  z-index: 9;
}

.vuiChatButton-isHidden,
.vuiChat--closed {
  visibility: hidden;
  opacity: 0;
}

.vuiChatButton {
  padding: 8px 12px;
  font-size: 14px;
  color: #2c313a;
  background-color: rgb(217, 226, 255);
  border: 1px solid #cbcdde;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: all 0.2s;
  animation: popUp 0.4s cubic-bezier(0.5, 0, 0.5, 1) 1;
}
.vuiChatButton:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  translate: translateY(-20px);
}

@keyframes popUp {
  0% {
    transform: translateY(40px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.vuiChat {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #cbcdde;
  background-color: #f3f7fb;
}
@media screen and (max-height: 600px) {
  .vuiChat {
    bottom: 4px;
    height: calc(100vh - 2 * 4px);
  }
  .vuiChat .vuiChat__conversation {
    max-height: 100%;
  }
}
@media screen and (max-width: 600px) {
  .vuiChat {
    right: 4px;
    width: calc(100vw - 2 * 4px);
    max-width: 100% !important;
  }
}

.vuiChat--tall {
  bottom: 4px;
  height: calc(100vh - 2 * 4px);
}
.vuiChat--tall .vuiChat__conversation {
  max-height: 100%;
}

.vuiChat--fullScreen {
  height: calc(100vh - 2 * 4px);
  width: calc(100vw - 2 * 4px);
  max-width: 100% !important;
}
.vuiChat--fullScreen .vuiChat__conversation {
  max-height: 100%;
}

.vuiChat__header {
  padding: 8px 12px;
  font-size: 14px;
  color: #2c313a;
  background-color: rgb(217, 226, 255);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  z-index: 2;
}

.vuiChat__conversation {
  flex-grow: 1;
  max-height: 400px;
  overflow-y: auto;
}

.vuiChat__introduction {
  padding: 16px 24px 0;
  font-size: 14px;
  color: #000;
}

.vuiChat__turns {
  font-size: 14px;
}

.vuiChat__conversationActions {
  padding: 12px;
}

.vuiChat__input {
  border-top: 1px solid #e3e4f3;
  padding: 8px 12px;
}

.vuiChatPanel {
  position: absolute;
  z-index: 5;
  top: 4px;
  left: 4px;
  right: 4px;
  bottom: 4px;
  padding: 4px 12px;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.vuiCodeContainer {
  position: relative;
  border-left: 4px solid #cbcdde;
  max-height: 480px;
}

.vuiCodeContainer--fullHeight {
  max-height: 100%;
}

.vuiCodeCopyButton {
  position: absolute;
  right: 4px;
  top: 4px;
}

.vuiCodePre {
  padding: 0 !important;
  margin: 0 !important;
  max-height: inherit;
}

.vuiCode {
  display: block;
  width: 100%;
  padding: 16px 24px;
  background-color: #f3f7fb;
  color: #2c313a;
  font-family: "Roboto Mono", monospace;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 12px !important;
}

@keyframes drawerIn {
  0% {
    right: -680px;
  }
  100% {
    right: 0;
  }
}
.vuiDrawer {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 680px;
  background-color: #ffffff;
  border-left: 1px solid #cbcdde;
  z-index: 11;
  animation: drawerIn 0.2s cubic-bezier(0, 1, 0, 1);
}

.vuiDrawerHeader {
  padding: 24px 24px;
}

.vuiDrawerContent {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.vuiDrawerContent__inner {
  padding: 24px 24px;
}

.vuiDrawer--primary .vuiDrawerHeader {
  background-color: rgb(217, 226, 255);
  color: #2c313a;
}

.vuiDrawer--danger .vuiDrawerHeader {
  background-color: #fae9eb;
  color: #c41535;
}

.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  gap: 0;
}

.vuiFlexContainer--spacingXxs {
  gap: 4px;
}

.vuiFlexContainer--spacingXs {
  gap: 8px;
}

.vuiFlexContainer--spacingS {
  gap: 12px;
}

.vuiFlexContainer--spacingM {
  gap: 16px;
}

.vuiFlexContainer--spacingL {
  gap: 24px;
}

.vuiFlexContainer--spacingXl {
  gap: 32px;
}

.vuiFlexContainer--spacingXxl {
  gap: 40px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiCheckboxLabel {
  font-size: 14px;
}

.vuiInput {
  appearance: none;
  border-radius: 4px;
  border: 1px solid #cbcdde;
  background-color: #ffffff;
}

.vuiInput--m {
  padding: 8px 16px;
  font-size: 14px;
}

.vuiInput--l {
  padding: 12px 16px;
  font-size: 18px;
}

.vuiInput--fullWidth {
  width: 100%;
}

.vuiInput-isInvalid {
  border-color: #c41535;
}

.vuiLabel {
  font-size: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiRadioButtonLabel {
  font-size: 14px;
}

.vuiSelect {
  position: relative;
  max-width: 240px;
  width: 100%;
}
.vuiSelect select {
  background-color: #ffffff;
  appearance: none;
  border-radius: 4px;
  border: 1px solid #cbcdde;
  color: #000;
  width: 100%;
}

.vuiSelect__caret {
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: auto;
  right: 12px;
}

.vuiSelect--m select {
  padding: 8px 16px;
  font-size: 14px;
  padding-right: 32px;
}
.vuiSelect--m .vuiSelect__caret {
  top: calc(50% - 10px);
}

.vuiSelect--l select {
  padding: 12px 16px;
  font-size: 18px;
  padding-right: 48px;
}
.vuiSelect--l .vuiSelect__caret {
  top: calc(50% - 14px);
}

.vuiSelect-isInvalid select {
  border-color: #c41535;
}

.vuiSuperRadioGroup {
  display: grid;
  gap: 8px;
}

.vuiSuperRadioButton {
  display: block;
  width: 100%;
  border-radius: 8px;
  padding: 12px 24px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s;
  text-decoration-color: #2c313a;
  text-align: left;
  background-color: #f3f7fb;
}
.vuiSuperRadioButton:hover {
  text-decoration: underline;
  text-decoration-color: #2c313a;
  background-color: rgb(217, 226, 255);
}

.vuiTextArea {
  appearance: none;
  border-radius: 4px;
  border: 1px solid #cbcdde;
  max-width: 100%;
  resize: none;
  min-height: 80px;
  font-size: 14px;
  padding: 12px;
}

.vuiTextArea--fullWidth {
  width: 100%;
}

.vuiGridContainer {
  container-type: inline-size;
  width: 100%;
}

.vuiGrid {
  display: grid;
}

.vuiGrid--xss {
  column-gap: 4px;
  row-gap: 4px;
}

.vuiGrid--xs {
  column-gap: 8px;
  row-gap: 8px;
}

.vuiGrid--s {
  column-gap: 12px;
  row-gap: 12px;
}

.vuiGrid--m {
  column-gap: 16px;
  row-gap: 16px;
}

.vuiGrid--l {
  column-gap: 24px;
  row-gap: 24px;
}

.vuiGrid--xl {
  column-gap: 32px;
  row-gap: 32px;
}

.vuiGrid--xxl {
  column-gap: 40px;
  row-gap: 40px;
}

.vuiGrid--columns1 {
  grid-template-columns: 1fr;
}

.vuiGrid--columns2 {
  grid-template-columns: 1fr 1fr;
}

.vuiGrid--columns3 {
  grid-template-columns: 1fr 1fr 1fr;
}

@container (width < 800px) {
  .vuiGrid--columns3 {
    grid-template-columns: 1fr 1fr;
  }
}
@container (width < 500px) {
  .vuiGrid--columns2,
  .vuiGrid--columns3 {
    grid-template-columns: 1fr;
  }
}
.vuiHorizontalRule {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid;
  width: 100%;
}

.vuiHorizontalRule--accent {
  border-bottom-color: #551edf;
}

.vuiHorizontalRule--primary {
  border-bottom-color: rgb(38, 76, 214);
}

.vuiHorizontalRule--success {
  border-bottom-color: #04821f;
}

.vuiHorizontalRule--danger {
  border-bottom-color: #c41535;
}

.vuiHorizontalRule--warning {
  border-bottom-color: #965a15;
}

.vuiHorizontalRule--neutral {
  border-bottom-color: #cbcdde;
}

.vuiHorizontalRule--subdued {
  border-bottom-color: #e3e4f3;
}

.vuiIcon {
  line-height: 0;
}

.vuiIcon--inline {
  display: inline-block;
}

.vuiIcon--accent {
  color: #551edf !important;
}

.vuiIcon--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiIcon--success {
  color: #04821f !important;
}

.vuiIcon--warning {
  color: #965a15 !important;
}

.vuiIcon--danger {
  color: #c41535 !important;
}

.vuiIcon--subdued {
  color: #69707d !important;
}

.vuiIcon--neutral {
  color: #2c313a !important;
}

.vuiIcon--empty {
  color: #ffffff !important;
}

.vuiInfoTable {
  width: 100%;
  table-layout: fixed;
  border: 1px solid #e3e4f3;
}
.vuiInfoTable thead {
  background-color: #f3f7fb;
  border-bottom: 1px solid #e3e4f3;
}
.vuiInfoTable tbody tr {
  border-bottom: 1px solid #e3e4f3;
}
.vuiInfoTable th {
  font-size: 12px;
  font-weight: 600;
  padding: 8px 12px;
  text-align: left;
}
.vuiInfoTable td {
  font-size: 14px;
  vertical-align: middle;
}

.vuiInfoTable--paddingXxs td {
  padding: 4px 12px;
}

.vuiInfoTable--paddingXs td {
  padding: 8px 12px;
}

.vuiInfoTable--paddingS td {
  padding: 12px 12px;
}

.vuiInfoTableRow--sectionHeader {
  background-color: #f3f7fb;
  border-bottom: none !important;
}

.vuiInfoTableRow--footer {
  background-color: #f3f7fb;
}

.vuiLink {
  color: rgb(38, 76, 214) !important;
  text-decoration: none;
}
.vuiLink:hover {
  text-decoration: underline;
}

.vuiLink--button {
  display: inline;
}

.vuiListNumber {
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  background-color: #f3f7fb;
  color: #69707d;
  font-weight: 600;
  line-height: 0;
  align-items: center;
}

.vuiListNumber--m {
  width: 16px;
  height: 16px;
  padding: 16px;
  font-size: 16px;
}

.vuiListNumber--s {
  width: 12px;
  height: 12px;
  padding: 12px;
  font-size: 12px;
}

.vuiListNumber-isComplete {
  background-color: #eadfff;
  color: #551edf;
}

.vuiMenu {
  border: 1px solid #cbcdde;
  border-radius: 8px;
}

.vuiMenuItem + .vuiMenuItem {
  border-top: 1px solid #cbcdde;
}

.vuiMenuItem {
  display: block;
  width: 100%;
  padding: 12px 24px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  text-decoration-color: #2c313a;
  text-align: left;
}
.vuiMenuItem:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  text-decoration: underline;
  text-decoration-color: #2c313a;
}

@keyframes modalIn {
  0% {
    transform: translateX(40px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
.vuiModalContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: modalIn 0.2s cubic-bezier(0, 1, 1, 1);
  pointer-events: none;
}

.vuiModal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  max-height: calc(100vh - 200px);
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  z-index: 12;
  pointer-events: all;
}

.vuiModalHeader {
  padding: 16px;
}

.vuiModalContent {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.vuiModalContent__inner {
  padding: 24px 16px 40px;
}

.vuiModal--primary .vuiModalHeader {
  background-color: rgb(217, 226, 255);
  color: #2c313a;
}

.vuiModal--danger .vuiModalHeader {
  background-color: #fae9eb;
  color: #c41535;
}

.vuiNotificationList {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  animation: popTop 0.4s cubic-bezier(0.5, 0, 0.5, 1) 1;
}

.vuiNotificationList__notifications {
  padding: 4px;
  border-bottom-left-radius: 16px;
  transition: all 0.2s;
}

.vuiNotificationList--hasMany .vuiNotificationList__notifications {
  border-bottom-left-radius: 8px;
}

.vuiNotificationContainer {
  position: relative;
}

.vuiNotification {
  position: relative;
  z-index: 1;
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  color: #2c313a;
  width: 420px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: #ffffff;
}

.vuiNotificationPlaceholder {
  position: absolute;
  z-index: 0;
  bottom: 0;
}

.vuiNotificationPlaceholder1-isVisible {
  bottom: -4px;
  animation: popBottom1 0.2s cubic-bezier(0.5, 0, 0.5, 1) 1;
}

.vuiNotificationPlaceholder2-isVisible {
  bottom: -7px;
  animation: popBottom2 0.2s cubic-bezier(0.5, 0, 0.5, 1) 1;
}

@keyframes popTop {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  50% {
    transform: translateY(10px);
    opacity: 1;
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes popBottom1 {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  50% {
    transform: translateY(2px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes popBottom2 {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  50% {
    transform: translateY(8x);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
}
.vuiOptionsButtonLeft {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.vuiOptionsButtonRight {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 1px solid;
}

.vuiButtonPrimary.vuiOptionsButtonRight--accent {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--primary {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--success {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--danger {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--warning {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--neutral {
  border-left-color: rgba(44, 49, 58, 0.2);
}

.vuiButtonSecondary.vuiOptionsButtonRight--accent {
  border-left-color: rgba(85, 30, 223, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--primary {
  border-left-color: rgba(38, 76, 214, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--success {
  border-left-color: rgba(4, 130, 31, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--danger {
  border-left-color: rgba(196, 21, 53, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--warning {
  border-left-color: rgba(150, 90, 21, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--neutral {
  border-left-color: rgba(44, 49, 58, 0.2);
}

.vuiOptionsList {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.vuiOptionsList--scrollable {
  max-height: 220px;
  overflow-y: auto;
}

.vuiOptionsList--s .vuiOptionsListItem {
  padding: 5px 8px;
}

.vuiOptionsList--m .vuiOptionsListItem {
  padding: 5px 12px;
}

.vuiOptionsList--l .vuiOptionsListItem {
  padding: 8px 12px;
}

.vuiOptionsListItem {
  background-color: #ffffff;
  text-decoration: none;
}
.vuiOptionsListItem:hover {
  text-decoration: underline;
}

.vuiOptionsListItem--accent {
  color: #551edf;
}
.vuiOptionsListItem--accent:hover {
  color: #551edf;
  background-color: #eadfff;
}

.vuiOptionsListItem--primary {
  color: rgb(38, 76, 214);
}
.vuiOptionsListItem--primary:hover {
  color: rgb(38, 76, 214);
  background-color: rgb(217, 226, 255);
}

.vuiOptionsListItem--success {
  color: #04821f;
}
.vuiOptionsListItem--success:hover {
  color: #04821f;
  background-color: #e9f2e9;
}

.vuiOptionsListItem--danger {
  color: #c41535;
}
.vuiOptionsListItem--danger:hover {
  color: #c41535;
  background-color: #fae9eb;
}

.vuiOptionsListItem--warning {
  color: #965a15;
}
.vuiOptionsListItem--warning:hover {
  color: #965a15;
  background-color: #f4eee8;
}

.vuiOptionsListItem--neutral {
  color: #2c313a;
}
.vuiOptionsListItem--neutral:hover {
  color: #2c313a;
  background-color: #f3f7fb;
}

.vuiPopover {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  z-index: 13;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.vuiOptionsListItem__selected--unselected {
  visibility: hidden;
}

.vuiPopoverTitle {
  padding: 8px 12px;
  border-bottom: 1px solid #cbcdde;
  font-weight: 600;
  font-size: 14px;
  color: #2c313a;
}

.vuiPopoverContent {
  padding: 4px 0;
}

.vuiPopoverContent--padding {
  padding: 12px;
}

.vuiProgressBar {
  position: relative;
  border-radius: 4px;
  height: 12px;
  overflow: hidden;
}

.vuiProgressBar__empty,
.vuiProgressBar__bar,
.vuiProgressBar__outline {
  position: absolute;
  width: 100%;
  height: 100%;
}

.vuiProgressBar__empty {
  z-index: 0;
  background-color: #f3f7fb;
  box-shadow: inset rgba(0, 0, 0, 0.05) 0px 2px 2px;
}

.vuiProgressBar__bar {
  transition: all 0.2s;
  z-index: 1;
}

.vuiProgressBar__outline {
  z-index: 2;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.vuiProgressBar--accent .vuiProgressBar__bar {
  background-color: #551edf;
}

.vuiProgressBar--primary .vuiProgressBar__bar {
  background-color: rgb(38, 76, 214);
}

.vuiProgressBar--success .vuiProgressBar__bar {
  background-color: #04821f;
}

.vuiProgressBar--warning .vuiProgressBar__bar {
  background-color: #965a15;
}

.vuiProgressBar--danger .vuiProgressBar__bar {
  background-color: #c41535;
}

.vuiProgressBar--neutral .vuiProgressBar__bar {
  background-color: #69707d;
}

.vuiPrompt {
  position: relative;
  border-radius: 16px;
  transition: all 0.2s;
  word-wrap: break-word;
}

.vuiPrompt--speechBubble::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
  left: 48px;
  border-style: solid;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-width: 20px;
  margin-left: -20px;
  margin-bottom: -20px;
  border-top-color: #f3f7fb;
  border-bottom: 0;
}

.vuiPrompt--interactive:hover {
  background-color: #eadfff;
  color: #551edf;
}

.vuiPrompt--danger {
  color: #c41535;
  background-color: #fae9eb;
}

.vuiPrompt--neutral {
  color: #69707d;
  background-color: #f3f7fb;
}

.vuiPrompt--paddingXs {
  padding: 8px;
}

.vuiPrompt--paddingS {
  padding: 12px;
}

.vuiPrompt--paddingM {
  padding: 16px;
}

.vuiPrompt--paddingL {
  padding: 24px;
}

.vuiPrompt--paddingXl {
  padding: 32px;
}

.vuiPrompt--paddingXxl {
  padding: 64px;
}

.vuiScreenBlock {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vuiScreenBlock__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.vuiSearchInput {
  position: relative;
  display: flex;
  align-items: center;
}

.vuiSearchInput__input {
  flex-grow: 1;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  outline-width: 1px !important;
  outline-style: solid;
  outline-color: transparent;
  outline-offset: -1px !important;
}
.vuiSearchInput__input:focus-visible {
  outline-color: rgb(38, 76, 214) !important;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiSearchInput__submitButton {
  position: absolute;
  right: 12px;
  line-height: 0;
  color: #69707d;
  transition: all 0.2s;
}
.vuiSearchInput__submitButton:hover {
  color: #551edf;
}

.vuiSearchInput--m .vuiSearchInput__input {
  padding: 8px 16px;
  font-size: 14px;
}

.vuiSearchInput--l .vuiSearchInput__input {
  padding: 12px 16px;
  font-size: 18px;
}

.vuiSearchResult {
  position: relative;
}
.vuiSearchResult + .vuiSearchResult {
  margin-top: 24px;
}

.vuiSearchResultPosition {
  position: absolute;
  left: -42px;
  top: 0;
  font-weight: 600;
  padding: 8px;
  color: #69707d;
  padding: 4px 8px;
  width: 30px;
  text-align: center;
  font-size: 12px;
  border-radius: 8px;
  height: 23px;
  transition: all 0.2s;
}

.vuiSearchResultPosition--selected {
  background-color: rgb(38, 76, 214);
  color: #ffffff;
  height: 100%;
}

.vuiSearchSelectHeader {
  background-color: #f3f7fb;
  padding: 16px;
  border-bottom: 1px solid #cbcdde;
  font-weight: 600;
  font-size: 14px;
  color: #2c313a;
}

.vuiSearchSelect__search {
  padding: 4px 8px;
  border-bottom: 1px solid #cbcdde;
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiSpinner--xs {
  width: 16px;
  height: 16px;
}

.vuiSpinner--s {
  width: 24px;
  height: 24px;
}

.vuiSpinner--m {
  width: 32px;
  height: 32px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiSpinner__animation {
  width: 100%;
  height: 100%;
}

.vuiSummary {
  font-size: 16px;
}

.vuiSummaryCitation {
  vertical-align: middle;
  position: relative;
  top: -2px;
  display: inline-block;
  background-color: #f3f7fb;
  color: #69707d;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 600;
  line-height: 1.4;
  transition: all 0.2s;
}
.vuiSummaryCitation:hover {
  color: rgb(38, 76, 214);
  background-color: rgb(217, 226, 255);
  text-decoration: underline;
}

.vuiSummaryCitation-isSelected {
  background-color: rgb(38, 76, 214);
  color: #ffffff;
}

.vuiTable {
  width: 100%;
  table-layout: fixed;
}
.vuiTable thead {
  border-bottom: 1px solid #cbcdde;
}
.vuiTable tbody tr {
  border-bottom: 1px solid #e3e4f3;
}
.vuiTable tbody tr.vuiTableRow-isBeingActedUpon, .vuiTable tbody tr:not(.vuiTableRow--inert):hover {
  background-color: #f3f7fb;
}
.vuiTable tbody tr:last-child {
  border-bottom: 1px solid #cbcdde;
}
.vuiTable th {
  font-size: 14px;
  font-weight: 600;
  padding: 4px;
}
.vuiTable td {
  font-size: 14px;
  padding: 4px;
  vertical-align: middle;
  word-break: break-word;
}

.vuiTable--fluid {
  table-layout: auto;
}

.vuiTableCell {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vuiTableActions {
  display: flex;
  justify-content: flex-end;
}

.vuiTableManyPagesToken {
  padding: 0 8px;
}

.vuiTableManyPagesToken-isDisabled {
  opacity: 0.5;
}

.vuiTableHeaderSelect {
  width: 32px;
}

.vuiTableHeaderActions {
  width: 42px;
}

.vuiTableContent {
  height: 80px;
}

.vuiTabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cbcdde;
  justify-content: space-between;
}

.vuiTabs--s .vuiTab {
  padding: 8px 12px;
  font-size: 14px;
}

.vuiTabs--m .vuiTab {
  padding: 8px 16px;
  font-size: 16px;
}

.vuiTabs__tabs {
  display: flex;
  align-items: center;
}

.vuiTabs__appendedContent {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiTab {
  flex-grow: 0;
  flex-shrink: 0;
  color: #69707d;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: transparent 0px 1px 0px, transparent 0px -1px 0px inset;
  cursor: pointer;
}
.vuiTab:hover, .vuiTab:active {
  color: #2c313a;
  text-decoration: none;
}
.vuiTab:hover {
  background-color: #f3f7fb;
}
.vuiTab.vuiTab-isActive {
  color: #2c313a;
  box-shadow: rgb(38, 76, 214) 0px 1px 0px, rgb(38, 76, 214) 0px -1px 0px inset;
}

.vuiToggle {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.vuiToggle__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vuiToggle__input:checked + .vuiToggle__button {
  background-color: rgb(38, 76, 214);
}
.vuiToggle__input:focus-visible + .vuiToggle__button {
  outline: 2px solid rgba(38, 76, 214, 0.75);
  outline-offset: 2px;
}
.vuiToggle__input:checked + .vuiToggle__button:before {
  transform: translateX(16px);
}

.vuiToggle__button {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbcdde;
  transition: 0.2s;
  border-radius: 16px;
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}
.vuiToggle__button:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  transition: 0.2s;
  border-radius: 50%;
}

.vuiTopicButton {
  display: inline-block;
  text-decoration: none;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  transition: box-shadow 0.2s, border-color 0.2s;
  overflow: hidden;
  padding: 16px 24px;
  text-align: left;
}
.vuiTopicButton:hover {
  text-decoration: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px, rgb(38, 76, 214) 0 0 1px 1px;
  z-index: 1;
}

.vuiTopicButton--fullWidth {
  width: 100%;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText a {
  color: rgb(38, 76, 214) !important;
  text-decoration: none;
}
.vuiText a:hover {
  text-decoration: underline;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText table {
  width: 100%;
  table-layout: fixed;
  border: 1px solid #e3e4f3;
}
.vuiText table thead {
  background-color: #f3f7fb;
  border-bottom: 1px solid #e3e4f3;
}
.vuiText table tbody tr {
  border-bottom: 1px solid #e3e4f3;
}
.vuiText table th {
  font-size: 12px;
  font-weight: 600;
  padding: 8px 12px;
  text-align: left;
}
.vuiText table td {
  font-size: 14px;
  vertical-align: middle;
  padding: 12px 12px;
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}
.vuiText--xs h1 {
  font-size: 24px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--xs h2 {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs h3 {
  font-size: 15px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--xs h4 {
  font-size: 12px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}
.vuiText--s h1 {
  font-size: 28px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--s h2 {
  font-size: 21px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s h3 {
  font-size: 17.5px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--s h4 {
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}
.vuiText--m h1 {
  font-size: 32px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--m h2 {
  font-size: 24px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m h3 {
  font-size: 20px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--m h4 {
  font-size: 16px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}
.vuiText--l h1 {
  font-size: 36px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--l h2 {
  font-size: 27px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l h3 {
  font-size: 22.5px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--l h4 {
  font-size: 18px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
